export const ACCOUNT = "api/accounts";
export const GEO = "geo";
export const INDUSTRY = "api/industries";
export const DEPARTMENT = "api/departments";
export const USERGROUP = "api/usergroup";
export const FORM = "api/forms";
export const DOCUMENTS = "api/documents";
export const CONTACTS = "api/contacts";
export const EMAIL = "api/email";
export const USER = "api/user";
export const DOCUMENT_CONVERSION = "api/document-conversion";
export const TEMPLATE = "api/template";
export const GENERATE_ID = "api/generateid";
export const LINK = "api/link";
export const JOBS = "/api/job";
export const CANDIDATES = "/api/candidates";
export const LLM = "/api/llm";
